import ErrorToast from "../../components/common/toasts/ErrorToast";
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import usePremiumResource from "./hooks/usePremiumResource";
import { isProcessing } from "./constants";
import { Status } from "./components/Fields";
import { pageIndex, premiumPaths } from "./navigation";

export default function OrderList({ organization, token }) {
  const [params, setParams] = useSearchParams();
  const page = pageIndex(params);
  const {
    data: result,
    error,
    reload,
  } = usePremiumResource(
    token,
    `/organizations/${organization.id}/orders?page=${page}`,
  );
  const goToPage = (next) => {
    const updated = new URLSearchParams(params);
    if (next === 0) updated.delete("page");
    else updated.set("page", String(next + 1));
    setParams(updated);
  };
  return (
    <section className="card premium-panel">
      <div className="premium-toolbar">
        <h2>Świadectwa firmy</h2>
        <div className="premium-button-group">
          <button
            className="btn btn-outline-primary"
            disabled={!result && !error}
            onClick={reload}
          >
            Odśwież
          </button>
        </div>
      </div>
      <ErrorToast message={error} />
      {!result && !error && <p role="status">Ładowanie świadectw…</p>}
      {result && (
        <>
          {!result.orders.length ? (
            <div className="premium-empty">
              <p>
                {page
                  ? "Brak świadectw na tej stronie."
                  : "Nie ma jeszcze świadectw tej firmy."}
              </p>
              <p className="text-muted mb-0">
                Użyj przycisku „Nowe świadectwo”, aby dodać dokumenty jednej
                dostawy.
              </p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Utworzono</th>
                    <th>Faktura</th>
                    <th>Status</th>
                    <th className="text-end">Operacje</th>
                  </tr>
                </thead>
                <tbody>
                  {result.orders.map((order) => (
                    <tr key={order.id}>
                      <td>
                        {new Date(order.createdAt).toLocaleString("pl-PL")}
                      </td>
                      <td>
                        {order.invoiceNumbers ||
                          (isProcessing(order.status)
                            ? "W trakcie odczytu"
                            : "Nie podano")}
                      </td>
                      <td>
                        <Status status={order.status} />
                      </td>
                      <td className="text-end">
                        <Link
                          className="btn btn-outline-primary btn-sm"
                          to={premiumPaths.order(order.id)}
                        >
                          Otwórz świadectwo
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {(page > 0 || result.hasMore) && (
            <nav className="premium-pagination" aria-label="Strony świadectw">
              <span>Strona {page + 1}</span>
              <div className="premium-button-group">
                <button
                  className="btn btn-outline-primary"
                  disabled={page === 0}
                  onClick={() => goToPage(page - 1)}
                >
                  Poprzednie
                </button>
                <button
                  className="btn btn-outline-primary"
                  disabled={!result.hasMore}
                  onClick={() => goToPage(page + 1)}
                >
                  Następne
                </button>
              </div>
            </nav>
          )}
        </>
      )}
    </section>
  );
}
